import { render, staticRenderFns } from "./AreaCompany.vue?vue&type=template&id=49daf6e2&scoped=true&"
import script from "./AreaCompany.vue?vue&type=script&lang=js&"
export * from "./AreaCompany.vue?vue&type=script&lang=js&"
import style0 from "./AreaCompany.vue?vue&type=style&index=0&id=49daf6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49daf6e2",
  null
  
)

export default component.exports